import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import Loader from "../components/other/Loader";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import { useSelector } from "react-redux";

const UserReportMember = () => {
  const navigate = useNavigate();

  const { isToggle } = useSelector((state) => state.authReducer);
  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />
          <div class="ct_inner_dashbaord_main">
            <div>
              <ul class="d-flex align-items-center  gap-2 mb-0">
                <li>
                  {" "}
                  <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                    168 Reporter
                  </h4>
                </li>
              </ul>
            </div>
            <div class="ct_white_bg ct_mt_28 py-4">
              <div class="ct_all_multiple_imgage">
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
                <div className="position-relative ct_img_w_210">
                  <img
                    src="assets/img/girl.jpg"
                    alt=""
                    className="ct_img_w_210"
                  />
                  <div className="ct_group_member_overlay_name_34">
                    <p className="mb-0">Juan</p>
                    <small>Report Time</small>
                    <small>
                      <span className="me-2">Dec 20, 2024</span>
                      <span>10:00 AM</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade ct_assets_modal"
          id="ct_delete_modal"
          tabindex="-1"
          aria-labelledby="ct_delete_modalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header border-0 pt-0">
                <button
                  type="button"
                  class="btn-close ct_cloose_btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div class="modal-body border-0 ">
                <i className="fa-solid fa-trash-can ct_red_text ct_fs_30 text-center d-block mb-4"></i>
                <h4 class="text-center mb-2 ct_fw_600">Confirm Delete</h4>
                <p className="text-center mb-0">
                  Are you sure? you want to delete it.
                </p>

                <div class="modal-footer border-0 justify-content-center">
                  <button
                    type="button"
                    class="ct_orange_btn ct_cancel_btn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <a
                    type="button"
                    class=" bg-danger  ct_orange_btn  justify-content-center"
                    style={{ borderColor: "rgb(220, 53, 69)" }}
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </a>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserReportMember;
